<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="800"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          Update Shipping Method & Order Type
        </h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--begin::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <form id="updateForm" class="pa-3 mx-3 row elevation-0">
          <div class="col-12 h-75px">
            <v-select
              v-model="formData.shipping_type"
              :label="$t('shipping_type')"
              item-text="text"
              item-value="index"
              :items="shippingTypes"
              clearable
              outlined
              dense
              :error-messages="shippingTypeErrors"
              @input="$v.formData.shipping_type.$touch()"
              @blur="$v.formData.shipping_type.$touch()"
            />
          </div>
          <div class="col-12 h-75px">
            <v-select
              v-model="formData.order_type"
              :label="$t('order_type')"
              item-text="text"
              item-value="index"
              :items="orderTypes"
              clearable
              outlined
              dense
              :error-messages="orderTypeErrors"
              @input="$v.formData.order_type.$touch()"
              @blur="$v.formData.order_type.$touch()"
            />
          </div>
        </form>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="my-2 d-flex flex-grow-1 align-end justify-center">
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submit"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import validationMixin from "@/own/mixins/validationMixin";
import { required, requiredIf } from "vuelidate/lib/validators";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "UpdateShippingMethodAndOrderType",
  mixins: [validationMixin],
  props: ["items", "refresher", "pageLoader"],
  validations() {
    return {
      formData: {
        shipping_type: {
          required: requiredIf(function () {
            return this.formData.order_type === null;
          }),
        },
        order_type: {
          required: requiredIf(function () {
            return this.formData.shipping_type === null;
          }),
        },
      },
    };
  },
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      shipping_type: null,
      order_type: null,
    },
  }),
  methods: {
    async toggleModal() {
      this.reset();
      this.dialog = !this.dialog;
    },
    setOrders() {
      this.formData.order_ids = this.selected.map((item) => item.systemId);
    },
    reset() {
      this.$v.$reset();
      this.formData = {
        shipping_type: null,
        order_type: null,
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.pageLoader(true);

      const data = {
        order_ids: [...this.items.map((item) => item.id.id)],
      };

      if (this.formData.shipping_type)
        data.shipping_type = this.formData.shipping_type;
      if (this.formData.order_type) data.order_type = this.formData.order_type;

      ApiService.post(
        `fulfillment/orders/update_shipping_method_and_order_type`,
        data
      )
        .then((res) => {
          Swal.fire({
            title: "Success",
            html: `Shipping method and order type updated successfully`,
            icon: "success",
            showConfirmButton: true,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  computed: {
    shippingTypeErrors() {
      return this.handleFormValidation("shipping_type", this);
    },
    orderTypeErrors() {
      return this.handleFormValidation("order_type", this);
    },
    shippingTypes: function () {
      return this.$store.getters.getORDERSShippingTypes;
    },
    orderTypes: function () {
      return this.$store.getters.getORDERSOrderTypes;
    },
  },
};
</script>
